export const getToken = () => {
    // Retrieve the data from localStorage
    const userVASData = localStorage.getItem("userVASData");

    if (userVASData) {
        // Parse the stringified object into a JSON object
        const parsedData = JSON.parse(userVASData);

        // Return the token if it exists
        if (
            parsedData &&
            parsedData.responseDetails &&
            parsedData.responseDetails.token
        ) {
            return parsedData.responseDetails.token;
        }
    }

    return null;
};
